import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

// Confirm dialog component for importing a project from 3DX
const ConfirmDialog = ({ open, onOpenChange, onConfirm, isLoading = false }: ConfirmDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={(newOpen) => {
      // Prevent closing the dialog while import is in progress
      if (!isLoading) {
        onOpenChange(newOpen);
      }
    }}>
      <DialogContent 
        className={`z-[400] max-w-lg ${isLoading ? '[&>button]:opacity-50 [&>button]:cursor-not-allowed [&>button]:pointer-events-none' : ''}`}
      >
        <DialogHeader>
          <DialogTitle className="text-[24px] font-semibold">Confirm Import</DialogTitle>
        </DialogHeader>
        <div className="py-2">
          <p className="text-gray-500">Are you sure you want to import the selected Project from 3DX?</p>
        </div>
        <DialogFooter className="flex gap-2 justify-end">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isLoading} className="bg-blue text-white">
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDialog
